/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Button,
  Card,
  Divider,
  Table,
  Input,
  Tag,
  message as Message,
  Spin,
} from 'antd';
import { useLocation, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AdminNavbar } from '../layout/PageHeader';
import { AccountTypeContext } from '../dashboard/Dashboard';
import { colors } from '../../constants/colors';
import PROFILE_ICON from '../../assets/images/png/profileicon.png';
import {
  getOrders,
  handleDelete,
  getCookMeals,
} from '../../store/admin/actions';
import { getAdminState } from '../../store/admin/selector';
import { orderTimeDifference } from '../orders/components/CurrentOrders';
import _ from 'lodash';
import { getAppGlobalState } from '../../store/app-globals/selectors';
import { setError, setLoading } from '../../store/app-globals/actions';

const { Column } = Table;

export interface UsersProps {
  users: any;
}

export interface AdminProps {
  meals: any;
}

export interface OrderProps {
  orders: any[];
}

export const CurrentOrdersCard: React.FC<OrderProps> = ({ orders }) => {
  const [filteredorder, setFilterOrder] = useState<Array<{}>>();
  const filterOrders = _.filter(
    orders,
    order => !orderTimeDifference(order.consumptiondate)
  );

  const handleSearchUsers = (e: React.FormEvent<HTMLInputElement>) => {
    const matchtext = e.currentTarget.value.toLowerCase();
    const matchusers = filterOrders.filter(
      item =>
        item.title.toLowerCase().match(matchtext) ||
        item.status.toLowerCase().match(matchtext)
    );
    setFilterOrder(matchusers);
  };
  useEffect(() => {
    setFilterOrder(filterOrders);
  }, [orders]);
  return (
    <Card className="card2-wrap">
      <div className="card-header-wrap">
        <span>Current Orders</span>
      </div>
      <div className="offer-search-input">
        <Input placeholder="Search offers" onChange={handleSearchUsers} />
      </div>
      <Divider type="vertical" />
      <div className="table-offers-wrap">
        <Table
          dataSource={filteredorder}
          rowKey="title"
          style={{ padding: '20px' }}
        >
          <Column title="Offer Name" dataIndex="title" key="title" />
          <Column
            title="Offer Description"
            dataIndex="description"
            key="description"
          />
          <Column
            title="Status"
            dataIndex="status"
            key="status"
            render={(status: any) => (
              <Tag
                key={status}
                color={
                  status === 'accepted'
                    ? '#00A75A'
                    : status === 'waiting'
                    ? '#D34836'
                    : status === 'refused'
                    ? '#9c9c9c'
                    : '#9c9c9c'
                }
              >
                {status}
              </Tag>
            )}
          />
        </Table>
      </div>
    </Card>
  );
};

export const PastOrdersCard: React.FC<OrderProps> = ({ orders }) => {
  const [filteredorder, setFilterOrder] = useState<Array<{}>>();
  const filterOrders = _.filter(orders, order =>
    orderTimeDifference(order.consumptiondate)
  );

  const handleSearchUsers = (e: React.FormEvent<HTMLInputElement>) => {
    const matchtext = e.currentTarget.value.toLowerCase();
    const matchusers = filterOrders.filter(
      item =>
        item.title.toLowerCase().match(matchtext) ||
        item.status.toLowerCase().match(matchtext)
    );
    setFilterOrder(matchusers);
  };
  useEffect(() => {
    setFilterOrder(filterOrders);
  }, [orders]);
  return (
    <Card className="card2-wrap">
      <div className="card-header-wrap">
        <span>Past Orders</span>
      </div>
      <div className="offer-search-input">
        <Input placeholder="Search offers" onChange={handleSearchUsers} />
      </div>
      <Divider type="vertical" />
      <div className="table-offers-wrap">
        <Table
          dataSource={filteredorder}
          rowKey="title"
          style={{ padding: '20px' }}
        >
          <Column title="Offer Name" dataIndex="title" key="title" />
          <Column
            title="Offer Description"
            dataIndex="description"
            key="description"
          />
          <Column
            title="Status"
            dataIndex="status"
            key="status"
            render={(status: any) => (
              <Tag
                key={status}
                color={
                  status === 'accepted'
                    ? '#00A75A'
                    : status === 'waiting'
                    ? '#D34836'
                    : status === 'refused'
                    ? '#9c9c9c'
                    : '#9c9c9c'
                }
              >
                {status}
              </Tag>
            )}
          />
        </Table>
      </div>
    </Card>
  );
};

export const Offers: React.FC<AdminProps> = ({ meals }) => {
  const [filteredmeals, setFilterMeals] = useState<Array<{}>>();
  const filtermeal = _.sortBy(meals, 'title');

  const handleSearchUsers = (e: React.FormEvent<HTMLInputElement>) => {
    const matchtext = e.currentTarget.value.toLowerCase();
    const matchusers = filtermeal.filter(item =>
      item.title.toLowerCase().match(matchtext)
    );
    setFilterMeals(matchusers);
  };
  useEffect(() => {
    setFilterMeals(meals);
  }, [meals]);
  return (
    <Card className="card2-wrap">
      <div className="card-header-wrap">
        <span>Offers</span>
      </div>
      <div className="offer-search-input">
        <Input placeholder="Search offers" onChange={handleSearchUsers} />
      </div>
      <Divider type="vertical" />
      <div className="table-offers-wrap">
        <Table
          dataSource={filteredmeals}
          rowKey="title"
          style={{ padding: '20px' }}
        >
          <Column title="Offer Name" dataIndex="title" key="title" />
          <Column
            title="Offer Description"
            dataIndex="description"
            key="description"
          />
          <Column
            title="Action"
            key="action"
            render={(text, record: any) => (
              <Row justify="start">
                <Link to={`cookmeals/${record.id}`}>
                  <span style={{ color: colors.blue }}>View</span>
                </Link>
              </Row>
            )}
          />
        </Table>
      </div>
    </Card>
  );
};

export const SubHeader: React.FC<UsersProps> = ({ users }) => {
  const { isLoading, message, hasError } = useSelector(getAppGlobalState);
  const dispatch = useDispatch();
  const capitalize = (s: string) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  };
  const handleUserAction = (key: string, type: string) => {
    if (type === 'suspended' || type === 'activated') {
      if (
        window.confirm(`are you sure you want ${users.name} to be ${type} ?`)
      ) {
        dispatch(handleDelete(key, type));
      }
      return;
    } else {
      if (
        window.confirm(`are you sure you want ${users.name} to be deleted ?`)
      ) {
        dispatch(handleDelete(key, type));
      }
    }
  };
  useEffect(() => {
    if (hasError) {
      Message.error('Error deleting users');
      dispatch(setError(false, ''));
      dispatch(setLoading(false, ''));
      return;
    }
  }, [isLoading]);
  return (
    <Row justify="space-between" className="header-wrap">
      <Col>
        <Col span={4}>
          <span style={{ color: colors.blue }}>Profile</span>
        </Col>
        <Col>
          <span>
            {users.name} /{' '}
            {capitalize(users.accountType === 'i offer' ? 'i offer' : 'i seek')}{' '}
            {users.subAccountType === ''
              ? null
              : `/ ${
                  users.subAccountType === 'i offer' ? 'I offer' : 'I seek'
                }`}
          </span>
        </Col>
      </Col>
      <Col className="manage-status-indicator">
        {isLoading ? (
          <Spin tip={`${message}...`} />
        ) : (
          <div>
            <Button
              className="button-sus"
              style={
                users.status[0] === 'suspended'
                  ? { backgroundColor: colors.green }
                  : { backgroundColor: colors.orange }
              }
              onClick={() =>
                users.status[0] === 'active'
                  ? handleUserAction(users.key, 'suspended')
                  : handleUserAction(users.key, 'activated')
              }
            >
              <span>
                {users.status[0] === 'suspended'
                  ? 'Activate User'
                  : 'Suspend User'}
              </span>
            </Button>
            <Button
              className="button-del"
              onClick={() => handleUserAction(users.key, 'delete')}
            >
              <span>{`${message}` || 'Delete User'}</span>
            </Button>
          </div>
        )}
      </Col>
    </Row>
  );
};

export const Content: React.FC<UsersProps> = ({ users }) => {
  const dispatch = useDispatch();
  const getUserOrders = () => {
    dispatch(getOrders(users.key, users.accountType));
  };
  const getCooksOffers = () => {
    if (users.accountType === 'i offer' || users.subAccountType === 'i offer') {
      dispatch(getCookMeals(users.userid));
    }
  };

  // const handleUserAction = (key: string, type: string) => {
  //   if (type === 'photo') {
  //     if (window.confirm('are you sure you want to delete this phote ?')) {
  //       dispatch(handleDelete(key, type));
  //       history.push('/admin');
  //     }
  //   }
  // };

  // console.log(users);
  useEffect(getUserOrders, [dispatch]);
  useEffect(getCooksOffers, [dispatch]);

  const { orders, meals } = useSelector(getAdminState);
  return (
    <Col xs={24} sm={24} md={24} lg={24} className="manage-user-container">
      <SubHeader users={users} />
      <Row justify="center" style={{ padding: '10px' }}>
        <div
          style={{
            backgroundImage: `url(${
              users.image === '' ? PROFILE_ICON : users.image
            })`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            width: '750px',
            height: '350px',
            borderRadius: '20px',
          }}
        />

        <Row justify="start" style={{ width: '550px', padding: '20px' }}>
          <div>
            <Row>
              <span style={{ fontSize: '20px' }}>Name: {users.name}</span>
            </Row>
            <Row style={{ marginTop: '20px' }}>
              <span style={{ fontSize: '20px' }}>Phone: {users.phone}</span>
            </Row>
            <Row style={{ marginTop: '20px' }}>
              <span style={{ fontSize: '20px' }}>
                Address: {users.address && users.address.city}{' '}
                {users.address && users.address.street}
              </span>
            </Row>
            <Row style={{ marginTop: '20px' }}>
              <span style={{ fontSize: '20px' }}>
                Account Type:
                {`${users.accountType === 'i offer' ? ' I offer' : ' I seek'} ${
                  users.subAccountType !== ''
                    ? `${
                        users.subAccountType === undefined
                          ? ''
                          : `/ ${
                              users.subAccountType === 'i offer'
                                ? ' I offer'
                                : ' I seek'
                            }`
                      }`
                    : ''
                }`}
              </span>
            </Row>
            <Row style={{ marginTop: '20px' }}>
              <span style={{ fontSize: '20px' }}>Email: {users.email}</span>
            </Row>
            <Row style={{ marginTop: '20px' }}>
              <span style={{ fontSize: '20px' }}>Status: {users.status}</span>
            </Row>
          </div>
        </Row>
      </Row>
      <Col xs={24} sm={24} md={24} lg={24}>
        {users.accountType === 'i offer' ||
        users.subAccountType === 'i offer' ? (
          <Offers meals={meals} />
        ) : null}
        <CurrentOrdersCard orders={orders} />
        <PastOrdersCard orders={orders} />
      </Col>
    </Col>
  );
};

export const ManageUser: React.FC = () => {
  const [forWho, setForWho] = useState('Admin');
  const location = useLocation();
  const handleAccountTypeChange = () => {
    const tempForWho = forWho;
    setForWho(tempForWho);
  };
  return (
    <AccountTypeContext.Provider value={{ forWho, handleAccountTypeChange }}>
      <div className="admin">
        <Row justify="center">
          <AdminNavbar />
        </Row>
        <Row justify="center">
          <Content users={location.state} />
        </Row>
      </div>
    </AccountTypeContext.Provider>
  );
};
